module.exports = __webpack_public_path__ + "static/img/_4.61fbc0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/_4.png
// module id = cFX2
// module chunks = 1